
import {UIWGameManager} from '../UIWGameManager'
import {UIGameMapShipController} from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapShipController'
import {MechanicPirateState, MechanicShipState} from '@colonist/game-states'

export class UIWGameMapShipController extends UIGameMapShipController {
    constructor(uiGameManager: UIWGameManager, shipState: MechanicShipState, mechanicPirateState: MechanicPirateState | undefined) {
        super(uiGameManager, shipState, mechanicPirateState)
        uiGameManager.actionsController.activateShipButtons(shipState, mechanicPirateState)
    }
}
